import { useRelatedRecords } from "../../api/useRelatedRecords";
import { useFields } from "../../api/useFields";
import { FormatedField } from "../../types/fields.types";
import { ResponseScore } from "./psyEvaluations.types";

export const RESPONSES_SCORES_FIELDS = [
	"id",
	"raw_score",
	"calculated_score",
	"instrument_dimension.id",
	"instrument_dimension.name",
	"instrument_dimension.code",
	"instrument_dimension.description",
	"instrument_dimension.dimension_cut_offs.instrument_dimension_cutoffs_id.id",
	"instrument_dimension.dimension_cut_offs.instrument_dimension_cutoffs_id.label",
	"instrument_dimension.dimension_cut_offs.instrument_dimension_cutoffs_id.level",
	"instrument_dimension.dimension_cut_offs.instrument_dimension_cutoffs_id.value_min",
	"instrument_dimension.dimension_cut_offs.instrument_dimension_cutoffs_id.value_max",
	"instrument_dimension.dimension_cut_offs.instrument_dimension_cutoffs_id.description",
];

export const useScoresData = (instrumentResponseId: string) => {
	const { formatedFields, status: fieldsStatus } = useFields("responses_scores", {
		fieldsToRemove: { fieldNamesToRemove: ["instrument_response_id"] },
	});
	const { formatedFields: cutoffFields, status: cutoffFieldsStatus } = useFields("instrument_dimension_cutoffs");
	const levelField = cutoffFields.find((field) => field.field === "level");
	const levelColors = buildLevelColorsFromField(levelField);

	const scoresFieldsToQuery = RESPONSES_SCORES_FIELDS.join(",");

	const { data, status } = useRelatedRecords(
		"responses_scores",
		scoresFieldsToQuery,
		"instrument_response_id",
		instrumentResponseId,
		undefined,
		{ extraOptions: { sort: "instrument_dimension.sort" } },
	);

	const scores = (data?.items ?? []) as Array<ResponseScore>;
	const isLoading = status === "loading" || fieldsStatus === "loading" || cutoffFieldsStatus === "loading";
	const isError = status === "error" || fieldsStatus === "error" || cutoffFieldsStatus === "error";

	return { scores, formatedFields, levelColors, isLoading, isError };
};

export const buildLevelColorsFromField = (levelField: FormatedField | undefined) => {
	const optionChoices = (levelField?.settings?.options?.choices ?? []) as Array<{ value?: string; color?: string }>;
	const levelColors: Record<string, string> = {};
	for (const choice of optionChoices) {
		if (choice.value && choice.color) levelColors[choice.value] = choice.color;
	}
	return levelColors;
};
